<template>
    <div class="mx-auto col-lg-6 col-md-8 col-sm-12 header-margin">
        
        <div class="text-center p-3">
            <h3>{{ $t('auth.userProfileConfirm.title') }}</h3>
        </div>

        <div class="text-center p-3">
            {{ $t('auth.userProfileConfirm.text') }}
        </div>
   
        <form @submit.prevent="handleOnSubmit">

            <div  class="text-center">
                <div class="outer">
                    <div class="inline">
                        <div class="wrapper">
                            <div class="names">{{ $t('account.edit.name.first') }}</div>
                            <div class="colon">:</div>
                            <div class="value">{{formData.first_name ? formData.first_name : '-'}}</div>
                        </div>
                        <div class="wrapper">
                            <div class="names">{{ $t('account.edit.name.last') }}</div>
                            <div class="colon">:</div>
                            <div class="value">{{formData.last_name ? formData.last_name : '-'}}</div>
                        </div>
                        <div class="wrapper">
                            <div class="names">{{ $t('account.edit.birthDate') }}</div>
                            <div class="colon">:</div>
                            <div class="value">{{formData.birth_date ? formData.birth_date : '-'}}</div>
                        </div>
                    </div>
                </div>

                <table class="table text-center">
                    <tbody>
                        <tr>
                            <th class="back_btn">
                                <button style="width:80px" type="button"  class="btn btn-primary mr-3" @click="back">{{ $t('auth.userProfileConfirm.backBtn') }}</button>
                            </th>
                            <th class="submit_btn">
                                <button style="width:80px" type="button" @click="handleOnSubmit" class="btn btn-primary mr-2" :disabled="submitBtnDisabled()">{{ $t('auth.userProfileConfirm.finishUpdateBtn') }}</button>
                            </th>
                        </tr>
                    </tbody>
                </table>

            </div>
        </form>
    </div>
</template>

<script>
    import userService from '../../services/UserService';

    export default {
        name: 'edit-user-profile-module',

        components: {
        },

        data() {
            return {
                errors: this.getDefaultFields(),
                formData: this.getDefaultFields(),
            }
        },
        created() {
            this.getConfirmData();
        },
        methods: {
            back: function(event){
                this.$router.push('/account/edit-profile');
            },
            getDefaultFields() {
                return {
                    first_name: '',
                    last_name: '',
                    birth_date: '',
                };
            },
            submitBtnDisabled() {
                if (this.formData.first_name== '' ||
                this.formData.last_name== '' ||
                this.formData.birth_date== '' ||
                this.formData.password== '') {
                    return true
                } else {
                    return false
                }
            },
            async handleOnSubmit() {
                this.errors = this.getDefaultFields();
                try {
                    //プロフィール編集処理
                    await userService.editUserAccount({
                        ...this.formData
                    });
                    userService.getUserFrontendData(true);

                    sessionStorage.removeItem('formData')
                    this.$router.push('/account/edit-profile-complete');
                } catch (err) {
                    if (err.response.data.errors) {
                        err.response.data.errors.forEach(errItem => {
                            if (errItem.field) {
                                this.errors[errItem.field] = errItem.message[0];
                            }
                        })
                    }
                }
            },
            async getConfirmData() {
                if(sessionStorage.formData){
                    this.formData = JSON.parse(sessionStorage.formData);
                }
            },
        }
    }
</script>

<style scoped>
    .back_btn{
        text-align:right;
        font-weight:normal;
        width: 505px;
        padding-right: 0px;
    }
    .submit_btn {
        text-align:left;
        font-weight:normal;
        width: 500px;
        padding-left: 0px;
    }
    .colon{
        margin-right: 5px;    
    }
    .wrapper{
        display:flex;
        margin-bottom: 20px;
    }
    .table th, .table th {
        border-top: 0px solid #dee2e6;
    }
    .value{
        width:100px;
    }
    .outer{
        text-align:center
    }
    .inline{
        display:inline-block;
        text-align:left;
    }
    .names{
        width:105px;
    }
</style>
